import { createAsyncStore } from "common/axios/asyncModel";
import { QnaRepository } from "repository/qnaRepository";
import { QNA } from "repository/types/QNA.types";
import { DEFAULT_SERVICE_ID } from "common/service";

const qnaList = createAsyncStore();
const qnaDetail = createAsyncStore();
const qnaCreate = createAsyncStore();

const getQnaList = (params: QNA.GetQnaListParams = { serviceId: DEFAULT_SERVICE_ID, locale: 'ko', pageNo: 1, pageSize: 20 }) => {
    qnaList.onGetAll(() => QnaRepository.onGetQnaList(params));
}

const getQnaDetail = (qnaNo: number) => {
    qnaDetail.onGetAll(() => QnaRepository.onGetQnaDetail(qnaNo));
}

const createQna = (params: QNA.PostQnaParams) => {
    qnaCreate.onGetAll(() => QnaRepository.onPostQna(params));
}

export const qnaStore = {
    qnaList,
    qnaDetail,
    qnaCreate,
    getQnaList,
    getQnaDetail,
    createQna,
}
